import {
  BooleanInput,
  number,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useInput,
  useNotify,
  SaveButton,
  Toolbar,
} from "react-admin";
import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useWatch } from "react-hook-form";
import "./style.css";
import { configSettingsApi } from "../../providers/env";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Params, useParams } from "react-router";
import { useCustomPermissions } from "../../hooks/usePermissions";
const languageChoices = [
  { id: "All", name: "All" },
  { id: "Afrikaans", name: "Afrikaans" },
  { id: "Albanian", name: "Albanian" },
  { id: "Amharic", name: "Amharic" },
  { id: "Arabic", name: "Arabic" },
  { id: "Armenian", name: "Armenian" },
  { id: "Azerbaijani", name: "Azerbaijani" },
  { id: "Basque", name: "Basque" },
  { id: "Belarusian", name: "Belarusian" },
  { id: "Bengali", name: "Bengali" },
  { id: "Bahasa Indonesia", name: "Bahasa Indonesia" },
  { id: "Bahasa Melayu", name: "Bahasa Melayu" },
  { id: "Bosnian", name: "Bosnian" },
  { id: "Bulgarian", name: "Bulgarian" },
  { id: "Catalan", name: "Catalan" },
  { id: "Cebuano", name: "Cebuano" },
  { id: "Chinese", name: "Chinese" },
  { id: "Corsican", name: "Corsican" },
  { id: "Croatian", name: "Croatian" },
  { id: "Czech", name: "Czech" },
  { id: "Danish", name: "Danish" },
  { id: "Dutch", name: "Dutch" },
  { id: "English", name: "English" },
  { id: "Esperanto", name: "Esperanto" },
  { id: "Estonian", name: "Estonian" },
  { id: "Finnish", name: "Finnish" },
  { id: "French", name: "French" },
  { id: "Frisian", name: "Frisian" },
  { id: "Galician", name: "Galician" },
  { id: "Georgian", name: "Georgian" },
  { id: "German", name: "German" },
  { id: "Greek", name: "Greek" },
  { id: "Gujarati", name: "Gujarati" },
  { id: "Haitian Creole", name: "Haitian Creole" },
  { id: "Hausa", name: "Hausa" },
  { id: "Hawaiian", name: "Hawaiian" },
  { id: "Hebrew", name: "Hebrew" },
  { id: "Hindi", name: "Hindi" },
  { id: "Hmong", name: "Hmong" },
  { id: "Hungarian", name: "Hungarian" },
  { id: "Icelandic", name: "Icelandic" },
  { id: "Igbo", name: "Igbo" },
  { id: "Indonesian", name: "Indonesian" },
  { id: "Irish", name: "Irish" },
  { id: "Italian", name: "Italian" },
  { id: "Japanese", name: "Japanese" },
  { id: "Javanese", name: "Javanese" },
  { id: "Kannada", name: "Kannada" },
  { id: "Kazakh", name: "Kazakh" },
  { id: "Khmer", name: "Khmer" },
  { id: "Kinyarwanda", name: "Kinyarwanda" },
  { id: "Korean", name: "Korean" },
  { id: "Kurdish", name: "Kurdish" },
  { id: "Kyrgyz", name: "Kyrgyz" },
  { id: "Lao", name: "Lao" },
  { id: "Latvian", name: "Latvian" },
  { id: "Lithuanian", name: "Lithuanian" },
  { id: "Luxembourgish", name: "Luxembourgish" },
  { id: "Macedonian", name: "Macedonian" },
  { id: "Malagasy", name: "Malagasy" },
  { id: "Malay", name: "Malay" },
  { id: "Malayalam", name: "Malayalam" },
  { id: "Maltese", name: "Maltese" },
  { id: "Maori", name: "Maori" },
  { id: "Marathi", name: "Marathi" },
  { id: "Mongolian", name: "Mongolian" },
  { id: "Myanmar (Burmese)", name: "Myanmar (Burmese)" },
  { id: "Nepali", name: "Nepali" },
  { id: "Norwegian", name: "Norwegian" },
  { id: "Nyanja (Chichewa)", name: "Nyanja (Chichewa)" },
  { id: "Odia (Oriya)", name: "Odia (Oriya)" },
  { id: "Pashto", name: "Pashto" },
  { id: "Persian", name: "Persian" },
  { id: "Polish", name: "Polish" },
  { id: "Portuguese", name: "Portuguese" },
  { id: "Punjabi", name: "Punjabi" },
  { id: "Romanian", name: "Romanian" },
  { id: "Russian", name: "Russian" },
  { id: "Samoan", name: "Samoan" },
  { id: "Scots Gaelic", name: "Scots Gaelic" },
  { id: "Serbian", name: "Serbian" },
  { id: "Sesotho", name: "Sesotho" },
  { id: "Shona", name: "Shona" },
  { id: "Sindhi", name: "Sindhi" },
  { id: "Sinhala", name: "Sinhala" },
  { id: "Slovak", name: "Slovak" },
  { id: "Slovenian", name: "Slovenian" },
  { id: "Somali", name: "Somali" },
  { id: "Spanish", name: "Spanish" },
  { id: "Sundanese", name: "Sundanese" },
  { id: "Swahili", name: "Swahili" },
  { id: "Swedish", name: "Swedish" },
  { id: "Tagalog (Filipino)", name: "Tagalog (Filipino)" },
  { id: "Tajik", name: "Tajik" },
  { id: "Tamil", name: "Tamil" },
  { id: "Tatar", name: "Tatar" },
  { id: "Telugu", name: "Telugu" },
  { id: "Thai", name: "Thai" },
  { id: "Turkish", name: "Turkish" },
  { id: "Turkmen", name: "Turkmen" },
  { id: "Ukrainian", name: "Ukrainian" },
  { id: "Urdu", name: "Urdu" },
  { id: "Uyghur", name: "Uyghur" },
  { id: "Uzbek", name: "Uzbek" },
  { id: "Vietnamese", name: "Vietnamese" },
  { id: "Welsh", name: "Welsh" },
  { id: "Xhosa", name: "Xhosa" },
  { id: "Yiddish", name: "Yiddish" },
  { id: "Yoruba", name: "Yoruba" },
  { id: "Zulu", name: "Zulu" },
];
const handleKeyDown = (e: any) => {
  if (e.key === "-" || e.key === "e") {
    e.preventDefault();
  }
};
// Custom validator for tag array
const validateTagRequired = (value: string[] | undefined) => {
  if (!value || value.length === 0) {
    return "Please enter at least one card";
  }
  return undefined;
};

// Custom TagSelector using MUI Autocomplete
const TagSelector = (props: any) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useInput(props);

  const initOptions = () => {
    if (typeof value === "string") {
      return value.split(",").filter((v) => v.trim() !== "");
    }
    return Array.isArray(value) ? value : [];
  };
  const [options, setOptions] = useState<string[]>(initOptions);

  const handleChange = (_: any, newValue: string[]) => {
    const merged = Array.from(new Set([...options, ...newValue]));
    setOptions(merged);

    const commaSeparated = newValue.join(",");
    onChange(commaSeparated);
  };

  const parsedValue =
    typeof value === "string"
      ? value.split(",").filter((v) => v.trim() !== "")
      : value?.filter?.((v: string) => v.trim() !== "") || [];
  return (
    <Autocomplete
      multiple
      freeSolo
      className="autocomplete-custom"
      options={options}
      style={{ marginBottom: 8 }}
      value={parsedValue}
      onChange={handleChange}
      renderInput={(params) => (
        <>
          <Box>
            <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
              <Typography variant="body2">
                Pre Chat Label <span style={{ color: "red" }}>*</span>
              </Typography>
              <Tooltip
                title="This is to identify the username or name of the user from the prechat form."
                arrow
              >
                <HelpOutlineIcon
                  color="action"
                  fontSize="small"
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            </Box>
            <TextField
              {...params}
              label=""
              error={!!error}
              helperText={error?.message}
            />
          </Box>
        </>
      )}
    />
  );
};

// Conditional inputs
const GreetingMessageInput = () => {
  const enabled = useWatch({ name: "EnableGreetingMessage" });
  if (!enabled) return null;
  return (
    <Grid item xs={12} className="grid-custom">
      <Box>
        <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
          <Typography variant="body2">Greeting Message</Typography>
          <Tooltip title="The first message for greeting used by bot" arrow>
            <HelpOutlineIcon
              color="action"
              fontSize="small"
              style={{ cursor: "pointer" }}
            />
          </Tooltip>
        </Box>
        <TextInput
          source="GreetingMsg"
          label=""
          fullWidth
          validate={required("Please enter a greeting")}
        />
      </Box>
    </Grid>
  );
};

// Custom Toolbar with permission check
const LineToolbar = () => {
  const { hasPermission } = useCustomPermissions();

  if (!hasPermission('line_settings', 'edit')) {
    return null;
  }

  return (
    <Toolbar>
      <SaveButton />
    </Toolbar>
  );
};

export const LineForm = (props: any) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const notify = useNotify();
  const params = useParams<Params>();
  const agentIdFromParams = params?.agentId;
  const agentId =
    props?.agentId ??
    agentIdFromParams ??
    (() => {
      try {
        return localStorage.getItem("agentId");
      } catch {
        return undefined;
      }
    })();
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await configSettingsApi.getLineConfig({ agentId });
        setData(res.data);
      } catch (err) {
        console.error("Error fetching config settings", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      await configSettingsApi.updateConfig({
        configSettingsUpdate: {
          ...values,
          agent_id: agentId,
          Channel: "line",
        },
      });
      notify("Update successfully", { type: "success" });
    } catch (error: any) {
      notify(error, { type: "error" });
    }
  };

  return (
    <Card sx={{ m: 2 }}>
      <CardHeader title="Line Setting" />
      <CardContent>
        <SimpleForm onSubmit={handleSubmit} record={data} toolbar={<LineToolbar />}>
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} md={6}>
              <Box>
                <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                  <Typography variant="body2">
                    Start Keyword <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>
                <TextInput
                  source="AISEStartKeyword"
                  fullWidth
                  label=""
                  validate={required()}
                />
              </Box>

              <Box>
                <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                  <Typography variant="body2">
                    Organization Name <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Tooltip title="Organization Name." arrow>
                    <HelpOutlineIcon
                      color="action"
                      fontSize="small"
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                </Box>
                <TextInput
                  validate={[required()]}
                  source="OrganizationName"
                  fullWidth
                  label=""
                />
              </Box>

              <Box>
                <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                  <Typography variant="body2">
                    Line Email
                  </Typography>
                  <Tooltip title="Email address for LINE account." arrow>
                    <HelpOutlineIcon
                      color="action"
                      fontSize="small"
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                </Box>
                <TextInput
                  source="LineEmail"
                  fullWidth
                  label=""
                  type="email"
                />
              </Box>

              <Box>
                <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                  <Typography variant="body2">
                    Line Password
                  </Typography>
                  <Tooltip title="Password for LINE account." arrow>
                    <HelpOutlineIcon
                      color="action"
                      fontSize="small"
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                </Box>
                <TextInput
                  source="LinePassword"
                  fullWidth
                  label=""
                  type="password"
                />
              </Box>

              <Box>
                <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                  <Typography variant="body2">
                    Character Count For Bot Response
                  </Typography>
                  <Tooltip title="This is the max characters per reply." arrow>
                    <HelpOutlineIcon
                      color="action"
                      fontSize="small"
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                </Box>
                <TextInput
                  source="CharacterCount"
                  label=""
                  fullWidth
                  type="number"
                  onKeyDown={handleKeyDown}
                  inputProps={{ min: 0 }}
                  validate={[required(), number()]}
                  parse={(value) => {
                    if (value === "") return value;
                    const num = parseInt(value, 10);
                    if (isNaN(num)) return value;
                    if (num < 0) return 0;
                    if (num > 1500) return 1500;
                    return num;
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box>
                <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                  <Typography variant="body2">
                    Stop Keyword <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>

                <TextInput
                  source="AISEStopKeyword"
                  fullWidth
                  label=""
                  validate={required()}
                />
              </Box>

              <Box>
                <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                  <Typography variant="body2">
                    Language <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>
                <SelectInput
                  source="Language"
                  label="Language"
                  choices={languageChoices}
                  fullWidth
                  validate={required()}
                  emptyText="Select a language"
                />
              </Box>
              {/* Force Transfer Count field commented out - not needed for Line/WhatsApp */}
              {/* <Box>
                <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                  <Typography variant="body2">
                    Force Transfer Count <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Tooltip
                    title="This is the number of times allowed for a user to accept transfer requests"
                    arrow
                  >
                    <HelpOutlineIcon
                      color="action"
                      fontSize="small"
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                </Box>
                <TextInput
                  source="ForcedTransferCount"
                  label=""
                  fullWidth
                  type="number"
                  onKeyDown={handleKeyDown}
                  validate={[required(), number()]}
                  parse={(value) => {
                    if (value === "") return value;
                    const num = parseInt(value, 10);
                    if (isNaN(num)) return value;
                    if (num < 1) return 1;
                    if (num > 6) return 6;
                    return num;
                  }}
                />
              </Box> */}
            </Grid>

            <Grid item xs={12} className="grid-custom">
              <TagSelector
                source="PreFormField"
                validate={validateTagRequired}
              />
            </Grid>
            <GreetingMessageInput />

            <Grid item xs={12} md={24}>
              <Box>
                <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                  <Typography variant="body2">
                    Enable Greeting Message
                  </Typography>
                  <Tooltip
                    title="This allows to set the value of greeting message"
                    arrow
                  >
                    <HelpOutlineIcon
                      color="action"
                      fontSize="small"
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                </Box>
                <BooleanInput source="EnableGreetingMessage" label="" />
              </Box>
            </Grid>
          </Grid>
        </SimpleForm>
      </CardContent>
    </Card>
  );
};